<template>
  <div id="view-tile" class="view-tile">
    <h2 class="page-heading">View Tile</h2>
    <ul>
      <!-- <li>
        <h4>{{ name }}</h4>
      </li>
      <li>Board ID: {{ boardId }}</li>
      <li>Enabled: {{ enabled }}</li>
      <li>Images folder name: {{ imagesFolderName }}</li>
      <li>Promoted: {{ promoted }}</li> -->
    </ul>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import db from './../firebaseInit';
import {canEdit} from './../helpers/roleAuthorisation';
export default {
  name: 'view-tile',
  title: 'View Tile',
  data() {
    return {};
  },
  beforeRouteEnter(to, from, next) {},
  watch: {},
  methods: {},
  computed: {},
};
</script>

<style lang="scss" scoped></style>
